import { ReactNode } from 'react';

import { BasicCheck } from '../../../icons/basic';
import { Typography } from '../../typography/Typography';

type Props = {
  message: string | ReactNode;
};

export const FeedbackSuccess = ({ message }: Props) => {
  return (
    <div className="flex items-center gap-2 bg-feedback-success p-4 text-feedback-success">
      <BasicCheck className="size-6 shrink-0 text-feedback-success" />
      <Typography
        variant="label-small"
        // break-word tailwind class doesn't work correctly
        className="[word-break:break-word]"
      >
        {message}
      </Typography>
    </div>
  );
};
